"use client"

import { AuthService } from '@repo/ui/lib/api/services/auth.service';
import { useMutation } from '@tanstack/react-query';

export type SignupInput = {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  planType: 'BASIC' | 'ADVANCED';
  // optional initial limits overrides could be added here if needed
};

export function useSignup() {
  return useMutation({
    mutationFn: async (input: SignupInput) => {
      const auth = new AuthService();
      return auth.signUp(input as any);
    }
  });
}


